import React from "react";
import { useTranslation } from "react-i18next";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

export const Policies = () => {
  const { t } = useTranslation();
  const countryCode = sessionStorage.getItem("LSCountryCode");
  const countryUrl = countryCode === "AU" ? "au" : "com";
  return (
    <Typography variant="body2" align="center">
      <Link
        color="inherit"
        href={`https://www.lifesafer.${countryUrl}/terms-of-use/`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ paddingRight: 15, textDecoration: "none" }}
      >
        {t("policies.termsofUseLabel")}
      </Link>
      <Link
        color="inherit"
        href={`https://www.lifesafer.${countryUrl}/privacy-policy/`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ paddingRight: 15, textDecoration: "none" }}
      >
        {t("policies.privacyLabel")}
      </Link>

      <Link
        color="inherit"
        href={`https://www.lifesafer.${countryUrl}/cookie-policy/`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ paddingRight: 15, textDecoration: "none" }}
      >
        {t("policies.cookiesLabel")}
      </Link>

      <Link
        color="inherit"
        href={`https://www.lifesafer.${countryUrl}/quality-policy/`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "none" }}
      >
        {t("policies.qualityLabel")}
      </Link>
    </Typography>
  );
};
